import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/role`;

export default {
  index(payload) {
    return Client.get(`${resource}/permission`, {
      params: payload,
    });
  },
};
